export default __webpack_public_path__ + "static/media/home-business-corporate-img-03.41715bd5.jpg";